import React from "react";
import '../TroublesForQuiz.scss';
import { openViewDeleteInputFormsForAnswerTrouble, setAnswerTroubleRate, 
    changeAnswerTroubleRate } from "../../troubleslice";
import { setSelectedIdAnswerTrouble, addAnswerRateOnTrouble } from "../../../../Admin/adminSlice";


const DataAnswer = (props) => {
    const { dispatch } = props;

   // CHECK ANSWER TROUBLE RATE
   const checkAnswerTroubleRate = (e) => {
        const dataRates = props.troublesData.answerTroubleRates;
       // console.log(dataRates);
            if (dataRates.length !== 0) {
            //CHECK IF EXIST

            const index = dataRates.findIndex(item => Number(item.answerId) === Number(e.answerId));
            console.log(index);  
           // console.log(dataRates[index].valueRate);
           // console.log(e.valueRate);
            if (index === -1) {
                console.log('answer rate doesnt exist');
                
                dispatch(setAnswerTroubleRate(e));
                //state.answerTroubleAnswerRateForServer = action.payload;
                return e;
            } else if(Number(dataRates[index].valueRate) !== Number(e.valueRate)){
                console.log('answer !== existed');
                dispatch(changeAnswerTroubleRate(index));
                return e;

            } else{
                return null;
            }
        } else {
            dispatch(setAnswerTroubleRate(e));
            return e;
        }
    }

    //HANDLE DELETE ANSWER TROUBLE


    const handleDeleteAnswer = (e) => {

        console.log('delete answer trouble' );
        //console.log(e.currentTarget.value);
        dispatch(setSelectedIdAnswerTrouble(e.currentTarget.value));
        dispatch(openViewDeleteInputFormsForAnswerTrouble());
    }
    // SET ANSWER TROUBLE UP RATE
    const handleUpRate =(e) => {
        const item = {
            answerId: e.currentTarget.value,
            valueRate: true,
        }
        const resultChecking = checkAnswerTroubleRate(item);
        if (resultChecking){
        console.log('start add new rate to DB');
        dispatch(addAnswerRateOnTrouble(item));
        }
    }
        // SET ANSWER TROUBLE UP RATE
    const handleDownRate =(e) => {
        const item = {
            answerId: e.currentTarget.value,
            valueRate: false,
        }
        const resultChecking = checkAnswerTroubleRate(item);
        if (resultChecking){
        console.log('start add new rate to DB');
        dispatch(addAnswerRateOnTrouble(item));
        }
    }


    //RENDER ANSWER

     const   resultArrayAnswers = props.dataAnswerTroubles;    
           // console.log(resultArrayAnswers);
         
            
                if (resultArrayAnswers) {
                    return (
                    resultArrayAnswers.map( item => {

                            
                        return (

                            <div className="answerBox" key={item.answer_id}>

                                <p className="index-name"> #{item.answer_id}</p>
                                <div className="feedback">
                                    <p className="upFeedback">{item.count_up}</p>
                                    <button className='upButton' value={item.answer_id} onClick={handleUpRate}></button>
                                    
                                    <button className='downButton' value={item.answer_id} onClick={handleDownRate}></button>
                                    <p className="downFeedback">{item.count_down}</p>
                                </div>
                                <div className="text-container">
                                    <p> {item.text}</p>
                                    </div>
                                <div className="back-box">
                                    <p className="user">User {item.user_id}</p>
                                    <button className='smallbtnDelete' value={item.answer_id} onClick={handleDeleteAnswer}></button>
                                </div>
                                
                            </div>
                        )})

                    
                    )
                        

       
                    } else return null;
                



        
   

    };
export default DataAnswer;